import React from 'react';

/**
 * Compact connection indicator for the gate detail screens. Both the
 * customer-side and admin-side gate detail endpoints attach a ``mqtt``
 * summary built by ``mqtt_service``; this component just paints it.
 *
 * The label is intentionally short ("מחובר" / "לא מחובר") — customers
 * don't need to know what a broker is, only whether the device is
 * currently reachable.
 */
function MqttStatusIndicator({ mqtt }) {
  if (!mqtt) return null;

  const config = STATUS_CONFIG[mqtt.status] || STATUS_CONFIG.offline;
  const tooltip = mqtt.last_status_at
    ? `דיווח אחרון: ${new Date(mqtt.last_status_at).toLocaleString('he-IL')}`
    : config.tooltip;

  return (
    <div className="mqtt-indicator" title={tooltip}>
      <span className="mqtt-indicator-dot" style={{ background: config.color }} />
      <span className="mqtt-indicator-label">{config.label}</span>
    </div>
  );
}

const STATUS_CONFIG = {
  online: {
    color: '#16a34a',
    label: 'מחובר',
    tooltip: 'הרכיב מתקשר עם השרת בזמן אמת',
  },
  offline: {
    color: '#dc2626',
    label: 'לא מחובר',
    tooltip: 'הרכיב לא מקוון — ייתכן שהוא כבוי או שאין WiFi באתר',
  },
  not_provisioned: {
    color: '#9ca3af',
    label: 'ממתין להתקנה',
    tooltip: 'עוד לא נוצרו פרטי חיבור לרכיב. הטכנאי יסיים זאת בהתקנה.',
  },
  no_device: {
    color: '#9ca3af',
    label: 'אין רכיב משויך',
    tooltip: 'השער עדיין לא חובר לרכיב פיזי',
  },
};

export default MqttStatusIndicator;
